import { render, staticRenderFns } from "./AnswersForPrint_v2.vue?vue&type=template&id=2e70a0de&"
import script from "./AnswersForPrint_v2.vue?vue&type=script&lang=js&"
export * from "./AnswersForPrint_v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports